import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveTourService,
  createTourService,
  deleteTourService,
  getAllActiveTourServices,
  getAllTourServices,
  getTourServiceByID,
  tourServiceImageUpload,
  updateTourService,
} from "./services/tourservice.services";
import { ITourService, ITourServiceInitialState } from "./tourserviceModel";

const initialState: ITourServiceInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  TourServiceList: [],
  TourServiceID: null,
  TourServiceDetail: {
    Title: "",
    URL: "",
    ShortDescription: "",
    LongDescription: "",
    Image: "",
    IsDisplayHome: false,
    IsActive: 1,
  },
};

const tourbookingSlice = createSlice({
  name: "tourbooking",
  initialState,
  reducers: {
    clearTourServiceDetails: (state) => {
      state.TourServiceDetail = initialState.TourServiceDetail;
    },
    setTourServiceID: (state, action) => {
      state.TourServiceID = action.payload;
    },
    clearTourServiceID: (state) => {
      state.TourServiceID = initialState.TourServiceID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTourServices.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllTourServices.fulfilled,
      (state, action: PayloadAction<ITourService[]>) => {
        state.loading = false;
        state.TourServiceList = action.payload || [];
      }
    );
    builder.addCase(getAllTourServices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TourServiceList = [];
    });
    builder.addCase(createTourService.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createTourService.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createTourService.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateTourService.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateTourService.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateTourService.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteTourService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteTourService.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteTourService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getTourServiceByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getTourServiceByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.TourServiceDetail = action.payload;
    });
    builder.addCase(getTourServiceByID.rejected, (state, action) => {
      state.formLoading = false;
      state.TourServiceDetail = initialState.TourServiceDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveTourServices.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveTourServices.fulfilled,
      (state, action: PayloadAction<ITourService[]>) => {
        state.loading = false;
        state.TourServiceList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveTourServices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TourServiceList = [];
    });
    builder.addCase(ActiveInactiveTourService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveTourService.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveTourService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(tourServiceImageUpload.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(tourServiceImageUpload.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(tourServiceImageUpload.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearTourServiceDetails, clearTourServiceID, setTourServiceID } =
  tourbookingSlice.actions;
export default tourbookingSlice.reducer;
